var path = window.location.pathname;
var crystalPlaqueOrderTotal = 0;

jQuery(document).ready(function($) {
	
	jQuery("#submitPayment").attr("disabled", true);
	
	if (path.match("crystal-plaque") && undefined === Cookies.get('smpOrderFormStep')) {
		Cookies.set('smpOrderFormStep', '1', { path: path});
	}
	
	setFormProgressBar();
	setFormTab('init');
	updatePricing();
	
	setTimeout(function(){
		checkFieldValidityOnload();
	}, 500);
	
	$(".cancel").on("click", function(e) {
		e.preventDefault();
		
		if (confirm("Are you sure you want to cancel? Your informaiton will not be saved")) {
			$.ajax({
				url: "/api/crystalPlaque/cancelOrderForm",
				type: "POST",
				data: {
					// action: 'cancelOrderForm',
					orderToken: $("#orderToken").val(),
					// token: localStorage.getItem('smToken')
				},
				dataType: "json",
				// contentType: false,
				// processData: false,
				success: function(response) {
					if (response.status == 1) {
						Cookies.set('smpOrderFormStep', 1, { path: path});
						// localStorage.removeItem('smToken');
						window.location = './';
					} else {
						$("#err").html('<div class="alert alert-danger" role="alert">' + response.message + '</div>');
					}
				},
				error: function(e) {
					console.log(e);
					$("#err").html(e).fadeIn();
				}
			});
		}
	});
	
	$(".next").on("click", function(e) {
		e.preventDefault();
		
		var checkStep = $(this).attr('id');
		if (checkStep == 'checkStep1') {
			tinymce.triggerSave();
		}
		
		var isFormValid;
		$('.needs-validation .form-step.active').find(':input').each(function() {
			isFormValid = isFormValid === false ? false : this.checkValidity();
			$(this).removeClass('is-valid is-invalid').addClass(this.checkValidity() ? 'is-valid' : 'is-invalid');
		});
		
		if (true === isFormValid) {
			var orderForm = $('#crystalPlaqueOrderForm')[0];
			var orderFormData = new FormData(orderForm);
			$('#crystalPlaqueOrderForm').find(':input:hidden').each(function(i, field) {
				var fname = $(field).attr('name');
				orderFormData.delete(fname);
			});
			
			// formData.append("action", "saveProgress");
			orderFormData.append("orderToken", $("#orderToken").val());
			orderFormData.append("orderStep", $(this).attr('data-step'));
			
			$.ajax({
				url: "/api/crystalPlaque/saveProgress",
				type: "POST",
				data: orderFormData,
				dataType: 'json',
				contentType: false,
				processData: false,
				beforeSend: function() {
					$("#err").fadeOut();
					$("#ajaxLoading").addClass('show');
				},
				success: function(response) {
					// console.log(response);
					if (response.status == 1) {
						var currentFormStep = Cookies.get('smpOrderFormStep');
						
						if (checkStep == 'checkStep1') {
							updatePricing();
						}
						
						Cookies.set('smpOrderFormStep', ++currentFormStep, { path: path});
						setFormProgressBar();
						setFormTab('next');
					} else if (response.status == 2) { // validation errors
						$.each(response.invalidFields, function(key, value) {
							$('#'+value+'').addClass('is-invalid');
						});
					} else {
						$("#err").html('<div class="alert alert-danger" role="alert">' + response.message + '</div>');
						$("#err").show();
					}
				},
				complete: function() {
					$("#ajaxLoading").removeClass('show');
				},
				error: function(e) {
					console.log(e);
					$("#err").html(e).fadeIn();
				}
			});
		}
	});
	
	$(".back").on("click", function(e) {
		e.preventDefault();
		var currentFormStep = Cookies.get("smpOrderFormStep");
		
		Cookies.set("smpOrderFormStep", --currentFormStep, { path: path });
		setFormProgressBar();
		setFormTab('back');
	});
	
	$('.needs-validation').find(':input[required]').on('change', function() {
		$(this).removeClass('is-valid is-invalid').addClass(this.checkValidity() ? 'is-valid' : 'is-invalid');
		
		validateFormStep();
	});
	
	// $('#useMyInfo').on('change', function() {
	// 	var useLoggedInUserInfo = $(this).is(':checked') ? 1 : 0;
	// 	var formData = new FormData();
	// 	formData.append('useLoggedInUserInfo', useLoggedInUserInfo);
	// 	formData.append('account_action', 'getBillingInfo');
	// 	
	// 	$.ajax({
	// 		url: '/api/account/getBillingInfo',
	// 		type: 'POST',
	// 		data: formData,
	// 		dataType: 'json',
	// 		contentType: false,
	// 		processData: false,
	// 		beforeSend: function() {
	// 			$("#err").fadeOut();
	// 		},
	// 		success: function(response) {
	// 			if (response.status == 200) {
	// 				$('#donor_first_name').val(response.first_name);
	// 				$('#donor_last_name').val(response.last_name);
	// 				$('#donor_email_address').val(response.email_address);
	// 				$('#donor_phone').val(response.billing_phone);
	// 				$('#donor_company_name').val(response.company_name);
	// 				$('#donor_address').val(response.billing_address);
	// 				$('#donor_suite').val(response.billing_suite);
	// 				$('#donor_city').val(response.billing_city);
	// 				$('#donor_state').val(response.billing_state);
	// 				$('#donor_zip').val(response.billing_zip);
	// 				checkFieldValidity();
	// 			}
	// 		},
	// 		error: function(e) {
	// 			console.log(e);
	// 			$("#err").html(e).fadeIn();
	// 		}
	// 	});
	// 	
	// 	checkFieldValidity();
	// });
});

jQuery(document).on('click', '#successCloseModal', function() {
	var currentFormStep = Cookies.get('smpOrderFormStep');
	
	Cookies.set('smpOrderFormStep', ++currentFormStep, { path: path});
	// setFormProgressBar();
	// setFormTab('next');
	window.location.reload();
});

function updatePricing() {
	var formData = new FormData();
	formData.append('orderToken', jQuery("#orderToken").val());
	
	jQuery.ajax({
		url: "/api/crystalPlaque/updatePrice",
		type: "POST",
		data: formData,
		dataType: 'json',
		contentType: false,
		processData: false,
		beforeSend: function() {
			jQuery("#err").fadeOut();
		},
		success: function(response) {
			crystalPlaqueOrderTotal = response.total;
			jQuery('#orderTotal').val(parseFloat(crystalPlaqueOrderTotal.replace(/\$|,/g, "")));
			jQuery('#orderTotalBar #orderPrice, #checkoutTotal span').html(crystalPlaqueOrderTotal);
		}
	});
}